import { Section } from '@policygenius/dif-ts-types';

const travelSchema: Section = {
  nodeType: 'SECTION',
  urn: 'urn:pg:interview:section:continue-online-travel-profile',
  content: '',
  rules: { operation: '=', field: 'children.all.valid', value: true },
  presentationRules: {
    question_insured_risk_activity_past_or_expect_travel_afghanistan_or_iraq_details: {
      field: 'question_insured_risk_activity_past_or_expect_travel_afghanistan_or_iraq.value',
      value: true,
      operation: '=',
    },
    question_insured_risk_activity_lived_or_traveled_overseas_past_two_years_details: {
      field: 'question_insured_risk_activity_lived_or_traveled_overseas_past_two_years.value',
      value: true,
      operation: '=',
    },
    section_future_travel_followup: {
      field: 'question_insured_risk_activity_travel_future_twelve_months.value',
      value: true,
      operation: '=',
    },
  },
  children: [
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      urn: 'urn:pg:interview:question:insured-risk-activity-past-or-expect-travel-afghanistan-or-iraq',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-risk-activity-past-or-expect-travel-afghanistan-or-iraq',
      },
      content:
        'Have you traveled to Afghanistan or Iraq in the past 2 years, or do you intend to travel to or reside in Afghanistan or Iraq in the next 12 months?',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      questionType: 'TEXT',
      urn: 'urn:pg:interview:question:insured-risk-activity-past-or-expect-travel-afghanistan-or-iraq-details',
      dataPoint: {
        dataType: 'text',
        subtype: 'long_text',
        urn: 'urn:pg:data-point:insured-risk-activity-past-or-expect-travel-afghanistan-or-iraq-details',
      },
      content: 'Please provide details.',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      urn: 'urn:pg:interview:question:insured-risk-activity-lived-or-traveled-overseas-past-two-years',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-risk-activity-lived-or-traveled-overseas-past-two-years',
      },
      content: 'Have you traveled or lived outside of the United States in the last 2 years?',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      questionType: 'TEXT',
      urn: 'urn:pg:interview:question:insured-risk-activity-lived-or-traveled-overseas-past-two-years-details',
      dataPoint: {
        dataType: 'text',
        subtype: 'long_text',
        urn: 'urn:pg:data-point:insured-risk-activity-lived-or-traveled-overseas-past-two-years-details',
      },
      content: 'Please provide details.',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      urn: 'urn:pg:interview:question:insured-risk-activity-travel-future-twelve-months',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-risk-activity-travel-future-twelve-months',
      },
      content:
        'Do you intend to travel or live outside of the United States or Canada within the next 12 months?',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'SECTION',
      urn: 'urn:pg:interview:section:future-travel-followup',
      content: '',
      rules: { operation: '=', field: 'children.all.valid', value: true },
      children: [
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-risk-activity-travel-future-twelve-months-destination',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-risk-activity-travel-future-twelve-months-destination',
          },
          content: 'Where?',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-risk-activity-travel-future-twelve-months-date-of-travel',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-risk-activity-travel-future-twelve-months-date-of-travel',
          },
          content: 'When?',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-risk-activity-travel-future-twelve-months-reason',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-risk-activity-travel-future-twelve-months-reason',
          },
          content: 'Why?',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-risk-activity-travel-future-twelve-months-duration',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-risk-activity-travel-future-twelve-months-duration',
          },
          content: 'For how long?',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
      ],
    },
  ],
};

export default travelSchema;
